/* eslint-disable no-param-reassign */
/*
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2021 Scandiweb, Inc (https://scandiweb.com)
 */

export class CheckoutShippingBillingContainerPlugin {
    onNationalIdNumberChange = (instance, ref, field) => {
        instance.setState({ nationalIdNumber: field.value });
    };

     aroundContainerFunctions = (originalMember, instance) => ({
         ...originalMember,
         // At some point binding is detatched (looks like SPWA bug, so we pass instance as argument).
         // Reviewing `this` closure in debugger, it returns correct instance,
         // however running the code makes `this` to be `undefined`
         onNationalIdNumberChange: this.onNationalIdNumberChange.bind(instance, instance)
     });

    aroundOnSubmitSuccess = (args, callback, instance) => {
        const { nationalIdNumber } = instance.state;

        if (nationalIdNumber && args.length) {
            args[1].national_id_number = nationalIdNumber;
        }

        callback.apply(instance, args);
    };

    aroundGetAddressById(args, callback, instance) {
        const { nationalIdNumber } = instance.state;
        const results = callback.apply(instance, args);

        if (nationalIdNumber) {
            results.national_id_number = nationalIdNumber;
        }

        return results;
    }

    aroundTrimAddressFields = (args, callback, instance) => {
        const { nationalIdNumber } = instance.state;
        const results = callback.apply(instance, args);

        if (nationalIdNumber) {
            results.national_id_number = nationalIdNumber;
        }

        return results;
    };
}

const {
    aroundContainerFunctions,
    aroundOnSubmitSuccess,
    aroundGetAddressById,
    aroundTrimAddressFields
} = new CheckoutShippingBillingContainerPlugin();

export const config = {
    'Scandipwa/Component/CheckoutShippingBilling/Container': {
        'member-function': {
            onSubmitSuccess: aroundOnSubmitSuccess,
            getAddressById: aroundGetAddressById,
            trimAddressFields: aroundTrimAddressFields
        },
        'member-property': {
            containerFunctions: aroundContainerFunctions
        }
    }
};

export default config;
